//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { UniversalItemType } from '@models/UniversalItemType';
import { getAllSelectedContent } from '@galleries/selectors/bulk-rights-selectors/getAllSelectedContent';
import { getIsAllSelectedContentBrandOwned } from '@galleries/selectors/bulk-rights-selectors/getIsAllSelectedContentBrandOwned';

export const canApproveSelectedItemsToInstaShop = createSelector(
  getAllSelectedContent,
  getIsAllSelectedContentBrandOwned,
  (allSelectedItems, areAllSelectedItemsBrandOwned) => {
    const misItemsSelected = allSelectedItems.some(
      (item) => item.itemType === UniversalItemType.MediaImport,
    );

    return areAllSelectedItemsBrandOwned && !misItemsSelected;
  },
);
